import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25 0C11.229 0 0 11.229 0 25s11.229 25 25 25 25-11.229 25-25c0-12.076-9.534-25-25-25zm19.809 16.843l-6.78 3.39c-1.377-3.602-4.237-6.886-8.262-8.263l3.39-6.886c5.508 2.331 9.533 6.78 11.652 11.758zM14.724 25c0-5.72 4.661-10.275 10.275-10.275 6.356 0 10.275 5.296 10.275 10.275 0 5.72-4.661 10.275-10.275 10.275-5.614 0-10.275-4.555-10.275-10.275zm2.119-19.81l3.39 6.886a13.855 13.855 0 0 0-8.263 8.263l-6.78-3.39A20.847 20.847 0 0 1 16.843 5.191zM5.19 33.158l6.78-3.39a13.855 13.855 0 0 0 8.262 8.263l-3.39 6.885c-5.296-2.224-9.534-6.462-11.653-11.758zM33.156 44.81l-3.39-6.886a13.855 13.855 0 0 0 8.263-8.263l6.885 3.39c-2.224 5.403-6.462 9.64-11.758 11.758z"
  })]
});